import React from 'react';
import { Button } from '@saviynt/design-system';

import testIds from '../../../../constants/testIds';
import useLocalization from '../../../../hooks/use-localize';

import './SchedulingFooter.css';

interface SchedulingFooterProps {
  onSave: () => void;
  isDisabled?: boolean;
  isLoading?: boolean;
  dataTestId?: string;
}

/**
 * Footer with save button for scheduling configuration.
 */
function SchedulingFooter({
  onSave,
  isDisabled = false,
  isLoading = false,
  dataTestId,
}: SchedulingFooterProps): JSX.Element {
  const t = useLocalization();

  return (
    <footer
      className='scheduling-footer'
      data-testid={dataTestId}
      role='contentinfo'>
      <Button
        type='button'
        onClick={onSave}
        isDisabled={isDisabled}
        isLoading={isLoading}
        loaderText={t('INTEGRATIONS.BUTTON.SAVING', 'Saving')}
        aria-label={t('INTEGRATIONS.BUTTON.SAVE')}
        dataTestId={testIds.SCHEDULING_FOOTER_SAVE_BUTTON}>
        {t('INTEGRATIONS.BUTTON.SAVE')}
      </Button>
    </footer>
  );
}

SchedulingFooter.defaultProps = {
  isDisabled: false,
  isLoading: false,
  dataTestId: undefined,
};

export default SchedulingFooter;
